"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFields = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const input_1 = require("@nbc-design/input");
const select_1 = require("@nbc-design/select");
require("./dateFields.css");
const utils_1 = require("./utils");
/** Allows the user to select dates with 3 inputs (day, month, year). When asking for a memorable date, such as a birthday date,
 *  always use date fields over a date picker. It is easier to use, better on mobile and autofill in browsers does a better job. */
const DateFields = ({ id, locale = 'fr', defaultValue, value, onChange, onKeyPress, className, dataTest = 'dateFields', disabled = false, validate, dayProps, dayRef, monthProps, monthRef, yearProps, yearRef, ariaLabel = {
    day: locale === 'fr' ? 'Jour' : 'Day',
    month: locale === 'fr' ? 'Mois' : 'Month',
    year: locale === 'fr' ? 'Année' : 'Year',
}, length, display = {
    day: true,
    month: true,
    year: true,
}, ...other }) => {
    const classes = (0, classnames_1.default)('dsc-dateFields', validate?.hasErrorDay && 'has-errorDay', validate?.hasErrorMonth && 'has-errorMonth', validate?.hasErrorYear && 'has-errorYear', length && `is-${length}`, className);
    const dayPlaceholder = utils_1.messages[locale].day;
    const { monthPlaceholder } = utils_1.messages[locale];
    const yearPlaceholder = utils_1.messages[locale].year;
    const onDateChange = ({ target }) => {
        const returnedValue = target.name === 'day' && target.value.length === 1 && parseInt(target.value, 10) <= 9
            ? `0${target.value}`
            : target.value;
        if (onChange) {
            onChange({ [target.name]: returnedValue }, {
                day: display.day
                    ? document.getElementById(`${id}__day`).value
                    : undefined,
                month: display.month
                    ? document.getElementById(`${id}__month`).value
                    : undefined,
                year: display.year
                    ? document.getElementById(`${id}__year`).value
                    : undefined,
            });
        }
    };
    const onDateKeyPress = (e) => {
        const regEx = /^[0-9]*$/;
        !regEx.test(e.key) && e.preventDefault();
        if (onKeyPress)
            onKeyPress(e);
    };
    // Because maxLength is not working on input type number
    const maxLengthCheck = (e) => {
        if (e.currentTarget.value.length > e.currentTarget.maxLength) {
            e.currentTarget.value = e.currentTarget.value.slice(0, e.currentTarget.maxLength);
        }
        else {
            dayProps?.onInput?.(e);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { ...other, id: id, className: classes, "data-test": dataTest, children: [display.day && ((0, jsx_runtime_1.jsx)(input_1.Input, { ...dayProps, ref: dayRef, id: `${id}__day`, name: "day", placeholder: dayPlaceholder, type: "number", inputMode: "numeric", maxLength: 2, onInput: maxLengthCheck, disabled: disabled && disabled, "aria-label": ariaLabel.day, ...(defaultValue ? { defaultValue: defaultValue.day } : {}), ...(value ? { value: value.day } : {}), ...(onChange ? { onChange: onDateChange } : {}), onKeyPress: onDateKeyPress })), display.month && ((0, jsx_runtime_1.jsx)(select_1.Select, { ...monthProps, id: `${id}__month`, ref: monthRef, name: "month", options: (0, utils_1.monthsOptions)(locale), disabled: disabled && disabled, "aria-label": ariaLabel.month, placeholder: monthPlaceholder, ...(defaultValue
                    ? { defaultValue: defaultValue.month }
                    : !value && { defaultValue: '' }), ...(value ? { value: value.month } : {}), ...(onChange ? { onChange: onDateChange } : {}) })), display.year && ((0, jsx_runtime_1.jsx)(input_1.Input, { ...yearProps, id: `${id}__year`, ref: yearRef, name: "year", placeholder: yearPlaceholder, type: "number", maxLength: 4, onInput: maxLengthCheck, disabled: disabled && disabled, "aria-label": ariaLabel.year, inputMode: "numeric", ...(defaultValue ? { defaultValue: defaultValue.year } : {}), ...(value ? { value: value.year } : {}), ...(onChange ? { onChange: onDateChange } : {}), onKeyPress: onDateKeyPress }))] }));
};
exports.DateFields = DateFields;
exports.DateFields.displayName = 'DateFields';
//# sourceMappingURL=dateFields.js.map